import { useContext } from 'react';

import { ComputerIcon, ConsoleIcon } from '@smartshell/ui-kit';

import {
  BarIcon,
  BilliardIcon,
  BoardGameIcon,
  ChooseIcon,
  CloakroomIcon,
  KitchenIcon,
  LoungeIcon,
  PointerIcon,
  RacingSimIcon,
  ReceptionIcon,
  RestroomIcon,
  TextIcon,
  VrIcon,
  WallCornerIcon,
  WallIcon,
  WallTIcon,
  WallXIcon,
} from 'components';
import { LocalizationContext } from 'localization';

import { ToolItem } from './interfaces';

export const useToolConfig = (): ToolItem[] => {
  const { t } = useContext(LocalizationContext);
  return [
    {
      type: 'choose' as const,
      key: t('host.map.toolbar.action_1'),
      icon: <ChooseIcon />,
      hotkey: 'V' || 'М',
      hotkeyCode: 'KeyV',
    },
    {
      type: 'text' as const,
      key: t('host.map.toolbar.action_2'),
      icon: <TextIcon />,
      hotkeyCode: 'KeyT',
    },
    {
      type: 'wall' as const,
      key: t('host.map.toolbar.action_3'),
      icon: <WallIcon />,
      hotkeyCode: 'KeyW',
    },
    {
      type: 'wall_corner' as const,
      key: t('host.map.toolbar.action_4'),
      icon: <WallCornerIcon />,
      hotkey: null,
    },
    {
      type: 'wall_t' as const,
      key: t('host.map.toolbar.action_5'),
      icon: <WallTIcon />,
      hotkey: null,
    },
    {
      type: 'wall_x' as const,
      key: t('host.map.toolbar.action_6'),
      icon: <WallXIcon />,
      hotkey: null,
    },
    {
      type: 'pointer' as const,
      key: t('host.map.toolbar.action_7'),
      icon: <PointerIcon />,
      hotkey: null,
    },
    {
      type: 'pc' as const,
      key: t('host.map.toolbar.action_8'),
      icon: <ComputerIcon color="primary" />,
      hotkey: null,
    },
    {
      type: 'console' as const,
      key: t('host.map.toolbar.action_9'),
      icon: <ConsoleIcon color="primary" />,
      hotkey: null,
    },
    {
      type: 'vr' as const,
      key: t('host.map.toolbar.action_10'),
      icon: <VrIcon />,
      hotkey: null,
    },
    {
      type: 'racing_sim' as const,
      key: t('host.map.toolbar.action_11'),
      icon: <RacingSimIcon />,
      hotkey: null,
    },
    {
      type: 'billiard' as const,
      key: t('host.map.toolbar.action_12'),
      icon: <BilliardIcon />,
      hotkey: null,
    },
    {
      type: 'board_game' as const,
      key: t('host.map.toolbar.action_13'),
      icon: <BoardGameIcon />,
      hotkey: null,
    },
    {
      type: 'reception' as const,
      key: t('host.map.toolbar.action_14'),
      icon: <ReceptionIcon />,
      hotkey: null,
    },
    {
      type: 'cloakroom' as const,
      key: t('host.map.toolbar.action_15'),
      icon: <CloakroomIcon />,
      hotkey: null,
    },
    {
      type: 'restroom' as const,
      key: t('host.map.toolbar.action_16'),
      icon: <RestroomIcon />,
      hotkey: null,
    },
    {
      type: 'lounge' as const,
      key: t('host.map.toolbar.action_17'),
      icon: <LoungeIcon />,
      hotkey: null,
    },
    {
      type: 'bar' as const,
      key: t('host.map.toolbar.action_18'),
      icon: <BarIcon />,
      hotkey: null,
    },
    {
      type: 'kitchen' as const,
      key: t('host.map.toolbar.action_19'),
      icon: <KitchenIcon />,
      hotkey: null,
    },
  ];
};
